// extracted by mini-css-extract-plugin
export default {"imageText":"careers_imageText__hduwa","picture1":"careers_picture1__PleZ0","paragraph1":"careers_paragraph1__WgJ9M"};